import { gql } from "@apollo/client";

export default gql`
  query Trailer($id: Int!) {
    trailer(id: $id) {
      id
      plate
      type
      isRefrigerated
      trackerBrand
      trackerId
      speedLimitDry
      speedLimitWet
      tareWeightKg
      temperatureMax
      temperatureMin
    }
  }
`;
